export default __webpack_public_path__ + "static/media/htw3.0df56a6f.svg";